import { QueryColumn } from "../models/QueryColumn";
import { QueryFilter } from "../models/QueryFilter";

export class Query {
    Id: number | null;
    Tenant: number;
    Code: string;
    Name: string;
    UserId: number | null;
    ObjectTableCode: string;
    GroupbyFieldCode: string | null;
    SortByFieldCode: string | null;
    SortDirection: string | null;
    IndexOrder: number;
    IsDeleted: boolean;
    QueryColumns: QueryColumn[];
    QueryFilters: QueryFilter[];
}